export default {
  point: 'Point:',
  point_other: 'Points:',
};
